<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-checkbox toggle @change="toggleSpam" :checked="(lead.status == 'spam')" class="custom-toggle-sm d-inline-flex m-1">Spam</d-checkbox>
      <d-checkbox toggle @change="toggleFinished" :checked="(lead.finished == 1)" class="custom-toggle-sm d-inline-flex m-1">Comprou</d-checkbox>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_LEAD_ } from '_modules/lead/components/LeadModel';

export default {
  name: 'lead-buttons',
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_LEAD_, this.lead);
    },
    toggleSpam() {
      this.$emit('toggleSpam', this.lead);
    },
    toggleFinished() {
      this.$emit('toggleFinished', this.lead);
    },
  },
  mounted() {},
};
</script>
